module.exports = __webpack_public_path__ + "static/media/logo.832c6bbb.svg";